<script lang="ts">
  import ChevronsDownUp from '@lucide/svelte/icons/chevrons-down-up';
  import ChevronsUpDown from '@lucide/svelte/icons/chevrons-up-down';

  import { getServices } from '../../app/context';
  import type { QuickFilter } from '../../model/filter';
  import { setAllCollapsed } from '../../model/ops';
  import { strings } from '../../strings';
  import Button from '../../ui/Button.svelte';
  import IconButton from '../../ui/IconButton.svelte';
  import ProgressPill from '../header/ProgressPill.svelte';
  import SearchBox from '../header/SearchBox.svelte';

  const { store, settings, view } = getServices();
  const filtering = $derived(view.query.trim() !== '' || settings.value.filter !== 'all');
  const id = $props.id();

  const filters: { value: QuickFilter; label: string }[] = [
    { value: 'all', label: strings.filterAll },
    { value: 'unrated', label: strings.filterUnrated },
    { value: 'commented', label: strings.filterCommented },
  ];
</script>

{#if view.editMode}
  <div class="border-b border-accent/30 bg-accent-soft print:hidden">
    <div class="mx-auto flex max-w-[100rem] items-center gap-3 px-4 py-2">
      <p class="min-w-0 flex-1 text-sm">
        <strong class="font-semibold">{strings.editingTitle}</strong>
        <span class="text-ink-muted">
          — {filtering ? strings.reorderDisabled : strings.editingHint}
        </span>
      </p>
      <Button
        size="sm"
        variant="primary"
        class="shrink-0"
        onclick={() => {
          view.editMode = false;
        }}
      >
        {strings.done}
      </Button>
    </div>
  </div>
{/if}
<div class="mx-auto flex max-w-[100rem] flex-wrap items-center gap-3 px-4 pt-3 print:hidden">
  <SearchBox class="w-full md:hidden" />
  <ProgressPill class="w-full sm:hidden" wide />
  <fieldset class="flex min-w-0 flex-1 items-center sm:flex-none">
    <legend class="sr-only">{strings.filterLabel}</legend>
    <div class="flex w-full rounded-lg bg-surface-2 p-0.5">
      {#each filters as filter (filter.value)}
        <label class="relative flex-1 sm:flex-none">
          <input
            type="radio"
            name="{id}-filter"
            value={filter.value}
            checked={settings.value.filter === filter.value}
            class="peer sr-only"
            onchange={() => {
              settings.update({ filter: filter.value });
            }}
          />
          <span
            class="flex h-8 cursor-pointer items-center justify-center rounded-md px-3 text-sm font-medium whitespace-nowrap text-ink-muted peer-checked:bg-surface peer-checked:text-ink peer-checked:shadow-sm peer-focus-visible:outline-2 peer-focus-visible:outline-focus dark:peer-checked:bg-line pointer-coarse:h-11"
          >
            {filter.label}
          </span>
        </label>
      {/each}
    </div>
  </fieldset>
  <!-- Same height and track as the filters, so the row ends on the content edge. -->
  <div class="flex items-center rounded-lg bg-surface-2 p-0.5">
    <IconButton
      size="sm"
      label={strings.expandAll}
      icon={ChevronsUpDown}
      onclick={() => store.apply((doc) => setAllCollapsed(doc, false), { record: false })}
    />
    <IconButton
      size="sm"
      tooltipAlign="end"
      label={strings.collapseAll}
      icon={ChevronsDownUp}
      onclick={() => store.apply((doc) => setAllCollapsed(doc, true), { record: false })}
    />
  </div>
</div>
